import React from "react";
import {
  RecordDrawer,
  RecordDrawerBody,
  RecordDrawerFacts,
  RecordDrawerHeader,
  RecordDrawerSection
} from "./RecordDrawer";

function formatDate(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

function formatMoney(value) {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function hasText(value) {
  return value != null && String(value).trim() !== "";
}

export function CustomerProfileModal({ row, onClose }) {
  if (!row) return null;

  const { customer, addressLine, location, walletBalance } = row;
  const memberSince = formatDate(customer.createdDate);
  const dob = formatDate(customer.dob);
  const hasAddress = hasText(addressLine) && addressLine !== "-";
  const hasLocation = hasText(location) && location !== "-";

  const tags = [
    { label: `ID #${customer.id}`, variant: "neutral" },
    ...(memberSince ? [{ label: `Since ${memberSince}`, variant: "neutral" }] : [])
  ];

  const footer = (
    <div className="record-drawer__grand">
      <span>Wallet balance</span>
      <strong>{walletBalance == null ? "—" : formatMoney(walletBalance)}</strong>
    </div>
  );

  return (
    <RecordDrawer open ariaLabel={`Customer ${customer.name}`} onClose={onClose} footer={footer}>
      <RecordDrawerHeader
        label="Customer profile"
        title={customer.name || "Unnamed customer"}
        subtitle={hasText(customer.email) ? customer.email : "No email on file"}
        onClose={onClose}
        tags={tags}
      />
      <RecordDrawerBody>
        <RecordDrawerSection title="Contact">
          <RecordDrawerFacts
            columns={2}
            fields={[
              ["Email", customer.email, true],
              ["Phone", customer.phoneNo],
              ["WhatsApp", customer.whatsAppNo]
            ]}
          />
        </RecordDrawerSection>

        <RecordDrawerSection title="Personal">
          <RecordDrawerFacts
            columns={2}
            fields={[
              ["Gender", customer.gender],
              ["Date of birth", dob ?? "—"]
            ]}
          />
        </RecordDrawerSection>

        <RecordDrawerSection title="Delivery address">
          {hasAddress || hasLocation ? (
            <RecordDrawerFacts
              fields={[
                ...(hasAddress ? [["Address", addressLine, true]] : []),
                ...(hasLocation ? [["Location", location]] : [])
              ]}
            />
          ) : (
            <p className="record-drawer__muted">No address saved for this customer.</p>
          )}
        </RecordDrawerSection>
      </RecordDrawerBody>
    </RecordDrawer>
  );
}
